import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/Common/Buttons';
import LocalisedMessage from 'components/Common/LocalisedMessage';

const ErrorPage = ({ title, titleTextId, type, showButton, buttonText, buttonTextId, onButtonClick, children, intl }) => <section className="error-page">
  <div className="row">
    <div className="col-12 offset-sm-2 col-sm-8 offset-md-3 col-md-6 offset-lg-4 col-lg-4">
      <h1><LocalisedMessage id={ titleTextId } defaultMessage={ title } /></h1>
      { type === 'network' && <span className="fa-layers fa-fw" id="error-network-icon">
        <FontAwesomeIcon icon="cloud" size="4x" />
        <FontAwesomeIcon icon="slash" size="4x" />
        </span> }
      { type === 'notfound' && <span className="fa-layers fa-fw" id="error-notfound-icon">
        <FontAwesomeIcon icon="exclamation-circle" size="4x" />
        </span> }
      { type === 'server' && <span className="fa-layers fa-fw" id="error-server-icon">
        <FontAwesomeIcon icon="exclamation-circle" size="4x" />
        </span> }
      { type === 'unsupported' && <span className="fa-layers fa-fw" id="error-unsupported-icon">
        <FontAwesomeIcon icon="exclamation-circle" size="4x" />
        </span> }
      { children }
      {showButton && <Button className="col-6" value={ intl.formatMessage({ id: buttonTextId, defaultMessage: buttonText }) } onClick={ () => { if (onButtonClick != null) { onButtonClick(); } } } /> }
    </div>
  </div>
</section>;

ErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['network', 'notfound', 'server', 'unsupported']).isRequired,
  showButton: PropTypes.bool,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  titleTextId: PropTypes.string,
  buttonTextId: PropTypes.string
};

ErrorPage.defaultProps = {
  showButton: false,
  buttonText: 'Reload',
  onButtonClick: () => { window.location.reload(); },
  children: null,
  titleTextId: null,
  buttonTextId: 'error.buttonText'
};

export default injectIntl(ErrorPage);
